import { useEffect } from 'react'

import { Card, Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { Icon } from 'core/ui/components/icon/Icon'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { CONTEXTS, OfferCard } from 'legacy/containers/LoadsPage/OfferCard/OfferCard'

import { type RawRelatedLoadOffer } from '../../domain/RelatedLoad'
import { useRelatedLoadOffers } from '../hooks/useRelatedLoadOffers'

type RelatedLoadsListProps = {
  loadUUID: string
  context: keyof typeof CONTEXTS
}

export function RelatedLoadsList({ loadUUID, context }: RelatedLoadsListProps) {
  const { fetchRelatedLoadOffers, isLoading, relatedLoadOffersList } = useRelatedLoadOffers(context)
  const abortController = useAbortController()

  useEffect(() => {
    fetchRelatedLoadOffers({ loadUUID, config: abortController })
  }, [abortController, fetchRelatedLoadOffers, loadUUID])

  if (isLoading || relatedLoadOffersList.length === 0) return null

  return (
    <Layout.Stack>
      <Card>
        <Card.Title>
          <Layout.Group gap="spacing-1">
            <Icon name="hot" size={16} color="neutral-darker" />
            <Text variant="heading-md-bold">Related loads</Text>
          </Layout.Group>
        </Card.Title>
        <Card.Divider />
        <Card.Body>
          <Layout.Stack gap="spacing-2" style={{ marginBottom: getToken('spacing-1') }}>
            {relatedLoadOffersList.map((loadOffer: RawRelatedLoadOffer) => (
              <OfferCard
                key={loadOffer.load.uuid}
                loadOffer={loadOffer}
                context={CONTEXTS[context]}
              />
            ))}
          </Layout.Stack>
        </Card.Body>
      </Card>
    </Layout.Stack>
  )
}
